import { makeStyles } from '@mui/styles';
import ReactTextareaAutocomplete from '@webscopeio/react-textarea-autocomplete';
import { primary } from 'apollo-react/colors';
import Typography from 'apollo-react/components/Typography';
import React from 'react';

import { useTranslation } from '../custom-hooks/useTranslation';
import { getUITA } from '../utils/commonUtils';

import '@webscopeio/react-textarea-autocomplete/style.css';

const useStyles = makeStyles({
  mainContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  editorExpression: {
    listStyle: 'none',
    minHeight: 50,
    color: '#000000',
    border: '1px solid #ccc',
    borderRadius: 4,
    transition: 'border-color 0.2s ease-in-out',
    '&:hover': {
      borderColor: primary,
    },
    '&:focus': {
      outline: 'none',
      border: `1px solid ${primary}`,
    },
  },
  containerStyles: {
    fontSize: '16px !important',
  },
  dropdownStyles: {
    border: '1px solid rgba(35, 114, 253, 0.08)',
    listStyle: 'none',
    outline: 'none',
    maxHeight: 150,
    overflowY: 'auto',
    borderRadius: 4,
  },
  listStyles: {
    '& [class*="rta__entity--selected"]': {
      color: '#000000',
      textDecoration: 'none',
      backgroundColor: 'rgba(35, 114, 253, 0.08)',
    },
    '& [class*="rta__item"]': {
      borderBottom: 'none !important',
    },
  },
  itemStyles: {
    fontFamily: 'Proxima Nova',
    fontSize: 14,
    color: '#000000',
    fontStyle: 'normal',
    fontStretch: 'normal',
    letterSpacing: 'normal',
    fontWeight: 400,
    backgroundColor: 'transparent',
    paddingTop: 4,
    paddingBottom: 4,
  },
  helperText: {
    textAlign: 'end',
    fontStyle: 'italic',
  },
});

const EntityAutocompleteTextarea = ({ value, onChange, onBlur, autocompleteFields = [] }) => {
  const classes = useStyles();
  const translateString = useTranslation();

  const filterAutocompleteItems = (searchText) =>
    autocompleteFields.filter(({ name = '' }) =>
      name.toLowerCase().includes(searchText.toLowerCase())
    );

  return (
    <div className={classes.mainContainer}>
      <ReactTextareaAutocomplete
        ui-ta={getUITA('formula-modal-textarea')}
        className={classes.editorExpression}
        onBlur={onBlur}
        afterWhitespace={true}
        onChange={onChange}
        loadingComponent={() => <div>{translateString('Loading')}</div>}
        containerClassName={classes.containerStyles}
        dropdownClassName={classes.dropdownStyles}
        listClassName={classes.listStyles}
        value={value}
        minChar={0}
        dropdownStyle={{ marginTop: 20 }}
        trigger={{
          '@': {
            dataProvider: (searchText) => filterAutocompleteItems(searchText),
            component: ({ entity: { name } }) => <div className={classes.itemStyles}>{name}</div>,
            output: (item) => {
              return {
                text: item.value,
                caretPosition: 'next',
              };
            },
            allowWhitespace: true,
          },
        }}
      />
      <Typography className={classes.helperText}>
        {translateString('Enter "@" to be able to select a field from the data model')}
      </Typography>
    </div>
  );
};

export default EntityAutocompleteTextarea;
